<h1>Godkend erstatningsliste</h1>
<p>Når du godkender erstatningslisten, accepterer du den angivne erstatning. Du vil herefter ikke kunne gøre indsigelser.</p>
<p class="total-amount">Samlet erstatningssum: {{compensationTotal  | currency:'DKK':true}}</p>
<label><input type="checkbox" [(ngModel)]="confirm" /> Jeg godkender erstatningslisten</label>
<div class="dialog-buttons">
    <button (click)="approve()" [disabled]="!confirm">Godkend erstatningsliste</button>
    <button class="primary" (click)="cancel()">Annuller</button>
</div>